import axios from "axios";
import qs from "qs";

const prepareUrl = (endpoint) => {
  return `${process.env.REACT_APP_API_SERVER}/${endpoint}`;
};

const requestFactory = (endpoint, payload = null) => {
  const config = {
    method: payload !== null ? "post" : "get",
    url: prepareUrl(endpoint),
    data: payload,
  };

  return axios(config);
};

const fetchSearch = (query = null, page = null) => {
  const uri = page
    ? `search${qs.stringify({ page }, { addQueryPrefix: true })}`
    : "search";
  return requestFactory(uri, { query });
};

const fetchPerson = (id) => requestFactory(`person/${id}`);

const fetchEdits = ({ data, id, entity }) => {
  const uri = entity === "mention" ? `editMention/${id}` : `editPerson/${id}`;
  return requestFactory(uri, data);
};

const fetchPersons = ({ page, letter }) => {
  const uri = letter
    ? `persons${qs.stringify({ page, letter }, { addQueryPrefix: true })}`
    : `persons${qs.stringify({ page }, { addQueryPrefix: true })}`;

  return requestFactory(uri);
};

export const fetchAddresses = () => {
  const config = {
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/addresses`,
  };

  return axios(config);
};

export default {
  fetchSearch,
  fetchEdits,
  fetchPersons,
  fetchPerson,
  fetchAddresses,
};



// WEBPACK FOOTER //
// ./src/helpers/api.js